import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import NewsListItem from './newsListItem/';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getALlnews, getCommentCount } from '../../../../../services/api';

class NewsListContainer extends React.PureComponent {
    state = {
        newsListContainer: styles.newsList,
        pagination: {
            current: 2,
            pageSize: 20,
        },
        newsData: [],
        loadMore: true,
        commentData: {},
    };
    static propTypes = {
        animateConfig: PropTypes.object,
        content: PropTypes.object,
    };

    static defaultProps = {
        animateConfig: {
            pt450: false,
        },
        content: {},
    };

    commentUrl = [];

    componentDidMount() {
        this.getFirstPageNews();
        this.getAllListCommentCount();
    }
    getCustomNewsTfList = ({ current, pageSize }) => {
        const req = this.props.content.initNewsData;

        req.sort((a, b) => {
            return Date.parse(b.newsTime) - Date.parse(a.newsTime);
        });

        const total = Math.ceil(req.length / pageSize);

        let start = (current - 1) * pageSize;
        let end = current * pageSize;

        const news = req.slice(start, end);

        const result = {
            news,
            total,
        };

        return result;
    };
    getFirstPageNews() {
        this.setState({
            newsData: this.getCustomNewsTfList({ current: 1, pageSize: 20 }).news,
        });
        console.log(this.state.newsData);
    }
    getList = () => {
        this.setState({
            pagination: {
                current: this.state.pagination.current + 1,
                pageSize: 20,
            },
        });
        const req = this.getCustomNewsTfList(this.state.pagination);

        const { news, total } = req;

        let nextNewsData = this.state.newsData;

        const result = nextNewsData.concat(news);

        if (this.state.pagination.current > total) {
            this.setState({
                loadMore: false,
            });
        } else {
            this.setState({
                newsData: result,
            });
        }
    };

    getAllListCommentCount = async () => {
        const req = this.props.content.initNewsData;

        // console.log(req)
        req.forEach(item => {
            this.commentUrl.push(item.commentUrl);
        });
        const data = await getCommentCount(this.commentUrl);

        console.log(data);

        const commentDataC = {};

        data.forEach(item => {
            commentDataC[item.doc_url] = item.count;
        });
        console.log(commentDataC);
        this.setState({
            commentData: commentDataC,
        });
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { animateConfig, content } = this.props;

        /**
         * 组件分发数据
         */
        return (
            <div className={animateConfig.pt450 ? styles.newsListPT450 : styles.newsList}>
                {this.state.newsData.map((item, index) => (
                    <NewsListItem initNewsData={item} key={index} commentCount={this.state.commentData} />
                ))}
                {this.state.loadMore ? (
                    <div className={styles.more} onClick={this.getList}>
                        <a>更多</a>
                    </div>
                ) : (
                    <div className={styles.noMore}>
                        <a>没有更多了</a>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(NewsListContainer);
